import vv_utils from './vv_utils';
import { simpleInvokeMachine, fullInvokeMachine } from "./vv_api";
import validateEmail from './email-validator';
import requestWebAuthn from './vv_webauthn';

/*-----------------------------------------------
|   User Settings Like Credentials and Profile
-----------------------------------------------*/


/*-----------------------------------------------
|   API Routes

// profile
rt.GET("/v1/settings/profile"
rt.POST("/v1/settings/profile",
rt.POST("/v1/settings/email/update",

// credential management
rt.GET("/v1/settings/credentials",
rt.GET("/v1/settings/credentials/:credential",
rt.POST("/v1/settings/credentials/:credential",
rt.DELETE("/v1/settings/credentials/:credential",

//FIDO
// enable/disable is only for FIDO
rt.POST("/v1/settings/credentials/:credential/enable",
rt.POST("/v1/settings/credentials/:credential/disable",
rt.POST("/v1/settings/webauthn/begin",
rt.POST("/v1/settings/webauthn/finish",

//Social
rt.POST("/v1/settings/social/connect",

//Password
rt.POST("/v1/settings/password/update",
-----------------------------------------------*/


const settingsdebugInit_onStart = () => {

  const alertbox = document.getElementById("split-alert");

  const { interpret } = window.XState;

  function checkValidity(context, event) {
    return new Promise((resolve, reject) => {
      
      let valid = true;

      if (valid) {
        return resolve("valid");
      } else {
        return reject(new Error('not valid'));
      }
    })
  }

  function getCreds(context, event) {
    
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/settings/credentials`, {}, 'GET', vv_utils.defaultTimeout);
  }


  function getProfile(context, event) {
    
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/settings/profile`, {}, 'GET', vv_utils.defaultTimeout);
  }

  function loadData(context, event) {
    return Promise.all([getCreds(context, event), getProfile(context, event)]);
  }

  const validationService = interpret(
    fullInvokeMachine.withConfig({
      actions: {
        loaded: () => {
          
        },
        message: (context, event) => {
          //vv_utils.clearInputValidation(form);
          vv_utils.clearalert(alertbox);
        },
        validationFailed: () => {
          vv_utils.showalert("There are validation errors, fix fields highlighted in red and submit again.", "danger", alertbox);
        },
        validationSucceeded: () => {
          validationService.send("PERFORM_ACTION");
        },
        actionFailed: (context, event) => {
          
          vv_utils.logError(context.error);
          vv_utils.showStateErrors("There was an unexpected error", context.error, alertbox);
        },
        actionSucceeded: (context, event) => {
          document.getElementById("profile").innerText = JSON.stringify(context.data[1], null, 2);
          document.getElementById("credentials").innerText = JSON.stringify(context.data[0], null, 2);
          validationService.send("LOAD_COMPLETE");
        }
      },
      services: {
        validate_service: (context, event) => checkValidity(context, event),
        action_service: (context, event) => { return loadData(context, event) }
      }
    })
  )
    .onTransition((state) => {  })
    .start();

  validationService.send("LOAD_COMPLETE");

  document.getElementById("loadProfile").addEventListener("click", e => {
    validationService.send("SUBMIT");
  });

  ///////////////////////////////////


  function checkEmailValidity(context, event) {
    return new Promise((resolve, reject) => {
      
      let valid = true;

      if (valid) {
        return resolve("valid");
      } else {
        return reject(new Error('not valid'));
      }
    })
  }

  function updateEmail(context, event) {
    
    let email = document.getElementById("new-email").value;
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/settings/email/update`, { "email": email }, 'POST', vv_utils.defaultTimeout);
  }

  const emailService = interpret(
    fullInvokeMachine.withConfig({
      actions: {
        loaded: () => {
          
        },
        message: (context, event) => {
          //vv_utils.clearInputValidation(form);
          vv_utils.clearalert(alertbox);
        },
        validationFailed: () => {
          vv_utils.showalert("There are validation errors, fix fields highlighted in red and submit again.", "danger", alertbox);
        },
        validationSucceeded: () => {
          emailService.send("PERFORM_ACTION");
        },
        actionFailed: (context, event) => {
          
          vv_utils.logError(context.error);
          vv_utils.showStateErrors("There was an unexpected error", context.error, alertbox);
        },
        actionSucceeded: (context, event) => {
          document.getElementById("profile").innerText = JSON.stringify(context, null, 2);
          if (context.data && context.data.pending_verification) {
            vv_utils.showalert("The update is now pending verification of your new email address. Check your inbox for the confirmation instructions.", "info", alertbox);
          }
          emailService.send("LOAD_COMPLETE");
        }
      },
      services: {
        validate_service: (context, event) => checkEmailValidity(context, event),
        action_service: (context, event) => updateEmail(context, event)
      }
    })
  )
    .onTransition((state) => {  })
    .start();

  emailService.send("LOAD_COMPLETE");

  document.getElementById("updateEmail").addEventListener("click", e => {
    emailService.send("SUBMIT");
  });

  ///////////////////////////////////


  function checkProfileValidity(context, event) {
    return new Promise((resolve, reject) => {
      
      let valid = true;

      if (valid) {
        return resolve("valid");
      } else {
        return reject(new Error('not valid'));
      }
    })
  }

  function updateProfile(context, event) {
    
    let profile = document.getElementById("new-profile").value;
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/settings/profile`, JSON.parse(profile), 'POST', vv_utils.defaultTimeout);
  }

  const profileService = interpret(
    fullInvokeMachine.withConfig({
      actions: {
        loaded: () => {
          
        },
        message: (context, event) => {
          //vv_utils.clearInputValidation(form);
          vv_utils.clearalert(alertbox);
        },
        validationFailed: () => {
          vv_utils.showalert("There are validation errors, fix fields highlighted in red and submit again.", "danger", alertbox);
        },
        validationSucceeded: () => {
          profileService.send("PERFORM_ACTION");
        },
        actionFailed: (context, event) => {
          
          vv_utils.logError(context.error);
          vv_utils.showStateErrors("There was an unexpected error", context.error, alertbox);
        },
        actionSucceeded: (context, event) => {
          document.getElementById("profile").innerText = JSON.stringify(context, null, 2);
          if (context.data && context.data.pending_verification) {
            vv_utils.showalert("The update is now pending verification of your new email address. Check your inbox for the confirmation instructions.", "info", alertbox);
          }
          profileService.send("LOAD_COMPLETE");
        }
      },
      services: {
        validate_service: (context, event) => checkProfileValidity(context, event),
        action_service: (context, event) => updateProfile(context, event)
      }
    })
  )
    .onTransition((state) => {  })
    .start();

  profileService.send("LOAD_COMPLETE");

  document.getElementById("updateProfile").addEventListener("click", e => {
    profileService.send("SUBMIT");
  });

  ///////////////////////////////////


  function checkCredValidity(context, event) {
    return new Promise((resolve, reject) => {
      
      let valid = true;

      if (valid) {
        return resolve("valid");
      } else {
        return reject(new Error('not valid'));
      }
    })
  }

  function updateCred(context, event) {
    
    let cred = JSON.parse(document.getElementById("new-cred-name").value);
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/settings/credentials/${cred.id}`, cred, 'POST', vv_utils.defaultTimeout);
  }

  const credService = interpret(
    fullInvokeMachine.withConfig({
      actions: {
        loaded: () => {
          
        },
        message: (context, event) => {
          //vv_utils.clearInputValidation(form);
          vv_utils.clearalert(alertbox);
        },
        validationFailed: () => {
          vv_utils.showalert("There are validation errors, fix fields highlighted in red and submit again.", "danger", alertbox);
        },
        validationSucceeded: () => {
          credService.send("PERFORM_ACTION");
        },
        actionFailed: (context, event) => {
          
          vv_utils.logError(context.error);
          vv_utils.showStateErrors("There was an unexpected error", context.error, alertbox);
        },
        actionSucceeded: (context, event) => {
          document.getElementById("credentials").innerText = JSON.stringify(context, null, 2);
          credService.send("LOAD_COMPLETE");
        }
      },
      services: {
        validate_service: (context, event) => checkCredValidity(context, event),
        action_service: (context, event) => updateCred(context, event)
      }
    })
  )
    .onTransition((state) => {  })
    .start();

  credService.send("LOAD_COMPLETE");

  document.getElementById("updateCred").addEventListener("click", e => {
    credService.send("SUBMIT");
  });


  /////////////////////////////////////////////////

  document.getElementById("signupFido").addEventListener("click", e => {
    requestWebAuthn({}, "register", alertbox)
      .then((context) => {
        document.getElementById("passkeyFirst").innerText = JSON.stringify(context, null, 2);
      });
  });

  /////////////////////////

  function getCred(context, event) {
    
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/settings/credentials/${event.id}`, {}, "GET");
  }

  const getCredMachine = interpret(
    simpleInvokeMachine.withConfig({
      actions: {
        actionFailed: (context, event) => {
          vv_utils.logError(context.error);
          //vv_utils.loading(false);
          vv_utils.showStateErrors("There was an unexpected error", context.error, alertbox);
        },
        actionSucceeded: (context, event) => {
          
          //vv_utils.loading(false);
          let jsonResponse = context.data;
          let cred = jsonResponse.data ? [...jsonResponse.data] : [];
          document.getElementById("credDetail").innerText = JSON.stringify(context.data, null, 2);
          getCredMachine.send("IDLE");
        }
      },
      services: {
        //eslint-disable-next-line
        action_service: (context, event) => { return getCred(context, event) }
      }
    })
  )
    .onTransition((state) => {  })
    .start();


  document.getElementById("getCredDetail").addEventListener("click", e => {
    let credId = document.getElementById("cred-id").value;
    let request = { "id": credId };
    getCredMachine.send("FETCH", request);
  });

  //////////////////

  function removeCred(context, event) {
    
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/settings/credentials/${event.id}`, {}, "DELETE");
  }

  const removeCredMachine = interpret(
    simpleInvokeMachine.withConfig({
      actions: {
        actionFailed: (context, event) => {
          vv_utils.logError(context.error);
          //vv_utils.loading(false);
          vv_utils.showStateErrors("There was an unexpected error", context.error, alertbox);
        },
        actionSucceeded: (context, event) => {
          
          //vv_utils.loading(false);
          let jsonResponse = context.data;
          let cred = jsonResponse.data ? [...jsonResponse.data] : [];
          document.getElementById("credDetail").innerText = JSON.stringify(context.data, null, 2);
          removeCredMachine.send("IDLE");
        }
      },
      services: {
        //eslint-disable-next-line
        action_service: (context, event) => { return removeCred(context, event) }
      }
    })
  )
    .onTransition((state) => {  })
    .start();


  document.getElementById("removeCredDetail").addEventListener("click", e => {
    let credId = document.getElementById("cred-id").value;
    let request = { "id": credId };
    removeCredMachine.send("FETCH", request);
  });

  //////////////////

  function disableCred(context, event) {
    
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/settings/credentials/${event.id}/disable`, {}, "POST");
  }

  const disableCredMachine = interpret(
    simpleInvokeMachine.withConfig({
      actions: {
        actionFailed: (context, event) => {
          vv_utils.logError(context.error);
          //vv_utils.loading(false);
          vv_utils.showStateErrors("There was an unexpected error", context.error, alertbox);
        },
        actionSucceeded: (context, event) => {
          
          //vv_utils.loading(false);
          let jsonResponse = context.data;
          let cred = jsonResponse.data ? [...jsonResponse.data] : [];
          document.getElementById("credDetail").innerText = JSON.stringify(context.data, null, 2);
          disableCredMachine.send("IDLE");
        }
      },
      services: {
        //eslint-disable-next-line
        action_service: (context, event) => { return disableCred(context, event) }
      }
    })
  )
    .onTransition((state) => {  })
    .start();


  document.getElementById("disableCredDetail").addEventListener("click", e => {
    let credId = document.getElementById("cred-id").value;
    let request = { "id": credId };
    disableCredMachine.send("FETCH", request);
  });

  //////////////////


  function enableCred(context, event) {
    
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/settings/credentials/${event.id}/enable`, {}, "POST");
  }

  const enableCredMachine = interpret(
    simpleInvokeMachine.withConfig({
      actions: {
        actionFailed: (context, event) => {
          vv_utils.logError(context.error);
          //vv_utils.loading(false);
          vv_utils.showStateErrors("There was an unexpected error", context.error, alertbox);
        },
        actionSucceeded: (context, event) => {
          
          //vv_utils.loading(false);
          let jsonResponse = context.data;
          let cred = jsonResponse.data ? [...jsonResponse.data] : [];
          document.getElementById("credDetail").innerText = JSON.stringify(context.data, null, 2);
          enableCredMachine.send("IDLE");
        }
      },
      services: {
        //eslint-disable-next-line
        action_service: (context, event) => { return enableCred(context, event) }
      }
    })
  )
    .onTransition((state) => {  })
    .start();


  document.getElementById("enableCredDetail").addEventListener("click", e => {
    let credId = document.getElementById("cred-id").value;
    let request = { "id": credId };
    enableCredMachine.send("FETCH", request);
  });

  //////////////////

  function addSocial(context, event) {
    
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/settings/social/connect`, { "provider": event.provider }, "POST");
  }

  const addSocialMachine = interpret(
    simpleInvokeMachine.withConfig({
      actions: {
        actionFailed: (context, event) => {
          vv_utils.logError(context.error);
          //vv_utils.loading(false);
          vv_utils.showStateErrors("There was an unexpected error", context.error, alertbox);
        },
        actionSucceeded: (context, event) => {
          
          //vv_utils.loading(false);
          let jsonResponse = context.data;
          let cred = jsonResponse.data ? [...jsonResponse.data] : [];
          document.getElementById("credDetail").innerText = JSON.stringify(context.data, null, 2);
          addSocialMachine.send("IDLE");
        }
      },
      services: {
        //eslint-disable-next-line
        action_service: (context, event) => { return addSocial(context, event) }
      }
    })
  )
    .onTransition((state) => {  })
    .start();


  document.getElementById("addSocialMS").addEventListener("click", e => {
    let request = { "provider": "microsoft" };
    addSocialMachine.send("FETCH", request);
  });


  document.getElementById("addSocialGoogle").addEventListener("click", e => {
    let request = { "provider": "google" };
    addSocialMachine.send("FETCH", request);
  });

  //////////////////

  function updatePassword(context, event) {
    
    return vv_utils.vv_fetch_state(vv_utils.vvenc`/v1/settings/password/update`, { "password": event.password }, "POST");
  }

  const updatePasswordMachine = interpret(
    simpleInvokeMachine.withConfig({
      actions: {
        actionFailed: (context, event) => {
          vv_utils.logError(context.error);
          //vv_utils.loading(false);
          vv_utils.showStateErrors("There was an unexpected error", context.error, alertbox);
        },
        actionSucceeded: (context, event) => {
          
          //vv_utils.loading(false);
          let jsonResponse = context.data;
          let cred = jsonResponse.data ? [...jsonResponse.data] : [];
          document.getElementById("passwordDetail").innerText = JSON.stringify(context.data, null, 2);
          updatePasswordMachine.send("IDLE");
        }
      },
      services: {
        //eslint-disable-next-line
        action_service: (context, event) => { return updatePassword(context, event) }
      }
    })
  )
    .onTransition((state) => {  })
    .start();


  document.getElementById("updatePassword").addEventListener("click", e => {
    let password = document.getElementById("password").value;
    let request = { "password": password };
    updatePasswordMachine.send("FETCH", request);
  });

  //////////////////

};
export default { settingsdebugInit_onStart };
